import { useAppSelector } from '../../../../../../App/redux/store';
import IndividualCircularLoader from '../../../../../../components/Loader/IndividualCircularLoader';
import { APIStatus } from '../../../../../../services/axiosEnums';
import Overlay from '../../../../../../shared/components/containers/overlay/Overlay';
import styles from './adDetailsForms.module.scss';

function SimilarAdDpeLoader() {
  const status = useAppSelector((state) => state.ad.similarAdDpes.apiStatus);

  if (status !== APIStatus.PENDING) return null;

  return (
    <Overlay className={styles.similarAdPlotloader}>
      <IndividualCircularLoader size={140} />
    </Overlay>
  );
}

export default SimilarAdDpeLoader;
